/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_DolarO_36_79(e) {
  let t = (0, ReactCompiler.c)(1),
    { nivel: n } = e;
  if (n !== `LECTURA`) return null;
  let r;
  return (
    t[0] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((r = (
          <span
            className={`rounded-full border border-(--border) bg-(--panel) px-2 py-0.5 text-[10px] text-(--text)`}
            children={`Solo lectura`}
          />
        )),
        (t[0] = r))
      : (r = t[0]),
    r
  );
}
